var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result"},[_c('div',[_c('div',{staticClass:"result__header"},[_vm._v(_vm._s(_vm.labels['bkheader']))]),_vm._v(" "),_c('div',{staticClass:"result__value"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),(_vm.header==2)?_c('div',{staticClass:"result__note",domProps:{"innerHTML":_vm._s(_vm.labels['bk2note'])}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-272b4fd3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Result.vue
// module id = null
// module chunks = 